const t = "compound_JGXYA", o = "paymentMethodButtonWrapper_QSSd3", p = {
  compound: t,
  paymentMethodButtonWrapper: o
};
export {
  t as compound,
  p as default,
  o as paymentMethodButtonWrapper
};
//# sourceMappingURL=paymentMethodCompound.module.scss.js.map
